import React from "react";
import { BaseApi } from "../../../store/apis/BaseApi";
import { BaseMultiSelect } from "../baseForm/BaseMultiSelect";

/**
 * @see [Documentation](../../../../Wiki/Documentations/FrontEnd/Components/BaseMultiSelectBox.md)
 */
export default function BaseMultiSelectBox({
  name,
  label,
  id,
  endpoint,
  control,
  errors,
  validationProps,
  defaultOptions,
  setValue,
  size,
  query,
  skip,
  ...rest
}) {
  if (!endpoint) return;

  const { data, isLoading } = BaseApi.endpoints[endpoint].useQuery(query, {
    skip: skip,
  });

  return (
    <BaseMultiSelect
      name={name}
      size={size}
      id={id || name}
      label={label}
      validationProps={validationProps}
      control={control}
      setValue={setValue}
      errors={errors}
      options={data || []}
      loading={isLoading}
      defaultOptions={defaultOptions}
      {...rest}
    />
  );
}
